// import external dependencies
import "jquery";
import "./autoload/gtm.js"; import "./autoload/slick.min.js";
import "./modules/about-us.js"; import "./modules/application-form.js"; import "./modules/blog.js"; import "./modules/checkout.js"; import "./modules/custom-select.js"; import "./modules/faq.js"; import "./modules/filter.js"; import "./modules/front-page-filters.js"; import "./modules/gift-card.js"; import "./modules/guide-page.js"; import "./modules/header.js"; import "./modules/jquery.datepicker.extension.range.min.js"; import "./modules/pillar-page.js"; import "./modules/single-post.js"; import "./modules/single-tour.js"; import "./modules/tours-archive.js"; import "./modules/tours-of-the-day.js";

import productViewDataLayer from "./autoload/gtm";
import { purchaseDataLayer } from "./autoload/gtm";

$(function() {
  productViewDataLayer($("body"), themeVars["title"]);

  if (themeVars["pagename"] == "confirmation-page") {
    let dataLayerItems = [];

    $(".tour-card__checkout").each(function() {
      let dataLayerItem = {
        item_brand: $(this).attr("data-brand"),
        item_id: $(this).attr("data-id"),
        item_name: $(this).attr("data-name"),
        item_variant: $(this).attr("data-variant"),
        price: $(this).attr("data-price"),
      };
      dataLayerItems.push(dataLayerItem);
    });

    purchaseDataLayer(
      $(".confirmation-page").attr("transaction-id"),
      $(".tour-card__checkout").attr("data-price"),
      dataLayerItems
    );
  }
});



// WEBPACK FOOTER //
// ./scripts/main.js